import moment from 'moment-timezone'

const isValidFormDate = (dateString) => {
  if (!dateString) return false
  return moment(dateString, 'MM/DD/YYYY', true).isValid()
}

export const normalizeTime = (timeStr) => {
  if (!timeStr) return ''
  const trimmed = timeStr.trim()
  if (/^\d{2}:\d{2}$/.test(trimmed)) return trimmed
  const rangeParts = trimmed.split(' - ').map((s) => s.trim())
  if (rangeParts.length >= 1 && /^\d{2}:\d{2}$/.test(rangeParts[0])) {
    return rangeParts[0]
  }
  return ''
}

const toUtcMoment = (utcDate, utcTime) => {
  if (!utcDate) return null
  const time = normalizeTime(utcTime)
  if (time) {
    const combined = moment.utc(`${utcDate} ${time}`, 'YYYY-MM-DD HH:mm', true)
    if (combined.isValid()) return combined
  }
  const dateOnly = moment.utc(utcDate)
  return dateOnly.isValid() ? dateOnly : null
}

/** UTC date + time from API → local 24h HH:mm for the time picker */
export const utcRsvpToLocal24h = (utcDate, utcTime) => {
  const utcMoment = toUtcMoment(utcDate, utcTime)
  if (!utcMoment) return ''
  return utcMoment.local().format('HH:mm')
}

/** UTC date + time from API → local date + time for the form */
export const parseUtcRsvpForForm = (utcDate, utcTime) => {
  const utcMoment = toUtcMoment(utcDate, utcTime)
  if (!utcMoment) {
    return { date: '', time: '' }
  }
  const local = utcMoment.local()
  return {
    date: local.format('MM/DD/YYYY'),
    time: local.format('HH:mm'),
  }
}

export const isValidRsvpFormDate = isValidFormDate

/** All fields required together, or all empty to clear RSVP info */
export const validateRsvpForm = (dateMMDDYYYY, timeHHmm, link) => {
  const hasDate = isValidFormDate(dateMMDDYYYY)
  const hasTime = Boolean(normalizeTime(timeHHmm))
  const hasLink = Boolean(link?.trim())
  const filledCount = [hasDate, hasTime, hasLink].filter(Boolean).length

  if (filledCount === 0) {
    return { isValid: true, isComplete: false }
  }

  if (filledCount === 3) {
    return { isValid: true, isComplete: true }
  }

  return {
    isValid: false,
    isComplete: false,
  }
}

export const getRsvpFieldErrors = (dateMMDDYYYY, timeHHmm, link) => {
  const validation = validateRsvpForm(dateMMDDYYYY, timeHHmm, link)
  if (validation.isValid) {
    return { rsvpDate: false, rsvpTime: false, rsvpLink: false }
  }

  const hasDate = isValidFormDate(dateMMDDYYYY)
  const hasTime = Boolean(normalizeTime(timeHHmm))
  const hasLink = Boolean(link?.trim())

  return {
    rsvpDate: !hasDate,
    rsvpTime: !hasTime,
    rsvpLink: !hasLink,
  }
}

/** Local date + time from form → UTC date + time for API payload */
export const buildUtcRsvpPayload = (dateMMDDYYYY, timeHHmm) => {
  const time = normalizeTime(timeHHmm)
  if (!isValidFormDate(dateMMDDYYYY) || !time) {
    return { date: '', time: '' }
  }

  const localDateTime = moment(
    `${dateMMDDYYYY} ${time}`,
    'MM/DD/YYYY HH:mm',
    true,
  )

  if (!localDateTime.isValid()) {
    return { date: '', time: '' }
  }

  const utc = localDateTime.utc()
  return {
    date: utc.format('YYYY-MM-DD'),
    time: utc.format('HH:mm'),
  }
}
